/* ss-all-reviews.js - «Alle anmeldelser»-siden (/pages/reviews). SS 20.09.2026. Lastes med defer fra
   templates/page.judgeme_all_reviews.liquid. Gjor for denne siden det ss-judgeme.js gjor for PDP/kolleksjon:
     1) snitt-tallet «4.8» ved stjernene (ss-judgeme.js treffer bare .jdgm-rev-widg__summary-stars)
     2) «Based on N reviews» -> butikkens tekst fra jdgmSettings for Judge.mes egen oversettelse rekker det
     3) fane-velger (Produktanmeldelser / Butikkanmeldelser) som <select> - samme klasse og logikk som
        kalis-judgeme-reviews-header.js (finnes bare i NO og UK), saa begge kan kjore uten aa lage to
     4) sorteringsvelgeren flyttes fra Judge.mes skjulte .jdgm-rev-widg__actions inn i .jdgm-row-stars
     5) «SKRIV EN ANMELDELSE» (store bokstaver fra admin) -> setningsform
     6) masonry: grid-row: span <hoyde+14> per kort i .jdgm-all-reviews__body / .jdgm-shop-reviews__body
   Alt er idempotent og kjores igjen paa Judge.mes events og DOM-endringer (Judge.me bygger header og body om
   ved fanebytte, sortering og «last flere»). Roerer ingenting utenfor #judgeme_all_reviews_page. */
(function () {
  'use strict';
  var GAP = 14;                       /* samme som ss-judgeme.js masonry() */
  var SELECT_CLASS = 'kalis-jdgm-tabselect';
  var root = document.getElementById('judgeme_all_reviews_page');
  if (!root) return;

  function q(s) { return root.querySelector(s); }
  function qa(s) { return [].slice.call(root.querySelectorAll(s)); }
  var nf;
  try { nf = new Intl.NumberFormat(document.documentElement.lang || 'en'); } catch (e) { nf = { format: function (n) { return String(n); } }; }

  /* 1) snitt-tall: 4.87 -> 4.8 (rundes ned, som paa PDP). Bare etter at Judge.me har bygget headeren
        (.jdgm-rev-widg__summary-inner finnes) - ellers havner spanet i en DOM som kastes. */
  function avg() {
    var st = q('.jdgm-rev-widg__summary-inner .jdgm-all-reviews__summary-stars'); if (!st) return;
    var inner = st.parentNode; if (inner.querySelector('.ss-jdgm-avg')) return;
    var hdr = q('.jdgm-all-reviews__header');
    var raw = (hdr && hdr.getAttribute('data-average-rating')) || '';
    if (!raw) { var m = (st.getAttribute('aria-label') || '').replace(',', '.').match(/[0-9]+(?:\.[0-9]+)?/); raw = m ? m[0] : ''; }
    var v = parseFloat(raw); if (isNaN(v) || v <= 0) return;
    var s = document.createElement('span');
    s.className = 'ss-jdgm-avg';
    s.textContent = (Math.floor(v * 10) / 10).toFixed(1);
    inner.insertBefore(s, st.nextSibling);
  }

  /* 2) summary-teksten: Judge.me leverer «Based on 311752 reviews» og oversetter foerst naar deres skript er ferdig.
        Teksten ligger i jdgmSettings.widget_summary_text («Basert paa {{ number_of_reviews }} anmeldelse/anmeldelser»;
        skraastrek = entall/flertall). Bare naar teksten fortsatt er den engelske - ellers eier Judge.me den. */
  function i18n() {
    var S = window.jdgmSettings || {};
    var el = q('.jdgm-all-reviews__summary-text'); if (!el || !S.widget_summary_text) return;
    if (!/^\s*Based on\b/i.test(el.textContent) || el.children.length) return;
    var hdr = q('.jdgm-all-reviews__header');
    var n = parseInt((hdr && hdr.getAttribute('data-number-of-reviews')) || '', 10); if (isNaN(n)) return;
    var t = S.widget_summary_text.replace(/\{\{\s*number_of_reviews\s*\}\}/g, nf.format(n));
    t = t.replace(/(\S+)\/(\S+)/g, function (_, a, b) { return n === 1 ? a : b; });
    t = t.replace(/^\s*\((.*)\)\s*$/, '$1');
    el.textContent = t;
  }

  /* 3) fane-velger. Kopi av logikken i kalis-judgeme-reviews-header.js: <select> foran «Skriv en anmeldelse» i
        .jdgm-row-stars, valg = .click() paa Judge.mes skjulte fane-lenke. Samme klasse: finnes velgeren alt
        (NO/UK, der det skriptet ogsaa kjorer) brukes den, saa det aldri blir to. */
  function subtabs() { return qa('.jdgm-subtab__name'); }
  function tabs() {
    var row = q('.jdgm-row-stars'); if (!row) return;
    var tabsEls = subtabs(); if (tabsEls.length < 2) return;
    var actions = row.querySelector('.jdgm-widget-actions-wrapper');
    var sel = row.querySelector('.' + SELECT_CLASS);
    if (!sel) {
      sel = document.createElement('select');
      sel.className = SELECT_CLASS;
      var S = window.jdgmSettings || {};
      var label = S.widget_reviews_subtab_text || S.widget_product_reviews_subtab_text || '';
      if (label) sel.setAttribute('aria-label', label);
      sel.addEventListener('change', function () {
        var cur = subtabs(); var target = cur[parseInt(sel.value, 10)];
        if (target) target.click();
      });
      if (actions && actions.parentNode === row) row.insertBefore(sel, actions); else row.appendChild(sel);
    }
    var labels = tabsEls.map(function (t) { return t.textContent.replace(/\s+/g, ' ').trim(); });
    var sig = labels.join('|');
    if (sel.dataset.labels !== sig) {
      sel.innerHTML = '';
      labels.forEach(function (l, i) { var o = document.createElement('option'); o.value = String(i); o.textContent = l; sel.appendChild(o); });
      sel.dataset.labels = sig;
    }
    var active = -1;
    tabsEls.forEach(function (t, i) { if (/jdgm--active/.test(t.className)) active = i; });
    if (active >= 0 && sel.selectedIndex !== active) sel.selectedIndex = active;
  }

  /* 4) sorteringsvelgeren. Judge.me bygger den i .jdgm-rev-widg__actions (skjult av CSS). Flyttes inn i raden,
        rett foer «Skriv en anmeldelse». Bygger Judge.me en ny (fanebytte), byttes den gamle ut. Bygger Judge.me
        raden om saa vaar flyttede velger faller ut av dokumentet, settes samme node inn igjen. */
  var movedSort = null;
  function sort() {
    var row = q('.jdgm-row-stars'); if (!row) return;
    var actions = q('.jdgm-rev-widg__actions');
    var fresh = actions && actions.querySelector('.jdgm-rev-widg__sort-wrapper, .jdgm-sort-dropdown-wrapper');
    var node = fresh || (movedSort && !document.contains(movedSort) ? movedSort : null);
    if (!node) return;
    if (movedSort && movedSort !== node && movedSort.parentNode) movedSort.parentNode.removeChild(movedSort);
    var write = row.querySelector('.jdgm-widget-actions-wrapper');
    if (write && write.parentNode === row) row.insertBefore(node, write); else row.appendChild(node);
    movedSort = node;
  }

  /* 5) «SKRIV EN BUTIKKANMELDELSE» -> «Skriv en butikkanmeldelse». Idempotent: en setning er ikke lenger bare store bokstaver. */
  function writeText() {
    var link = q('.jdgm-row-stars .jdgm-write-rev-link'); if (!link) return;
    var s = link.textContent.trim();
    if (s && s === s.toUpperCase() && s !== s.toLowerCase()) link.textContent = s.charAt(0) + s.slice(1).toLowerCase();
  }

  /* 6) masonry - samme teknikk som ss-judgeme.js: hvert kort faar grid-row: span <hoyde+GAP>, grid-auto-flow:dense
        legger det i korteste kolonne. align-items:start gjor at spanet ikke endrer kortets egen hoyde, saa
        ResizeObserveren under bare reagerer paa ekte endringer (bilder som laster, oversettelser, vindusbredde).
        Klassen ss-masonry settes foerst naar minst ett kort er maalt - et umaalt grid overlapper aldri.
        Skjult body (den andre fanen) gir hoyde 0 og hoppes over; naar den vises igjen, maaler observeren paa nytt. */
  var ro = (typeof ResizeObserver !== 'undefined') ? new ResizeObserver(function () { schedule(); }) : null;
  function masonry() {
    ['.jdgm-all-reviews__body', '.jdgm-shop-reviews__body'].forEach(function (sel) {
      var g = q(sel); if (!g) return;
      var cards = g.querySelectorAll('.jdgm-rev');
      if (!cards.length) { g.classList.remove('ss-masonry'); return; }
      var any = false;
      [].forEach.call(cards, function (c) {
        var h = Math.ceil(c.getBoundingClientRect().height);
        if (h > 0) { var span = 'span ' + (h + GAP); if (c.style.gridRowEnd !== span) c.style.gridRowEnd = span; any = true; }
        if (ro && !c.dataset.ssRo) { ro.observe(c); c.dataset.ssRo = '1'; }
      });
      if (ro && !g.dataset.ssRo) { ro.observe(g); g.dataset.ssRo = '1'; }
      if (any && !g.classList.contains('ss-masonry')) g.classList.add('ss-masonry');
    });
  }

  function run() { avg(); i18n(); tabs(); sort(); writeText(); masonry(); }

  /* throttle som i ss-judgeme.js: senest 80 ms etter foerste mutasjon i en bolge; observeren pauses mens vi selv
     endrer DOM, saa egne endringer ikke utloser nye runder. */
  var OBS_OPTS = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] };
  var timer = null, obs = null, busy = false;
  function schedule() {
    if (busy || timer) return;
    timer = setTimeout(function () {
      timer = null; busy = true;
      if (obs) obs.disconnect();
      try { run(); } catch (e) {}
      if (obs) obs.observe(root, OBS_OPTS);
      busy = false;
    }, 80);
  }
  run();
  obs = new MutationObserver(schedule);
  obs.observe(root, OBS_OPTS);
  ['jdgm.doneSetup', 'jdgm.doneSetupReviews', 'jdgm.doneAppendMoreReviewsInAllReviewsPage',
   'jdgm.openedTabInAllReviewsPage', 'jdgm.filteredInAllReviewsPage', 'jdgm.doneShowReviewsTab'].forEach(function (n) {
    document.addEventListener(n, schedule, false);
  });
  window.addEventListener('resize', schedule);
  document.addEventListener('click', function () { setTimeout(schedule, 400); }, true);
  /* widgeten lastes lazy og kode-splittet - kort polling som sikkerhetsnett (20 s), som kalis-judgeme-reviews-header.js */
  var tries = 0, poll = setInterval(function () { schedule(); if (++tries > 40) clearInterval(poll); }, 500);
})();
